var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01NowPriem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.541 3.83331H3.83268C3.32435 3.83331 2.83684 4.03525 2.47739 4.39469C2.11795 4.75414 1.91602 5.24165 1.91602 5.74998V19.1666C1.91602 19.675 2.11795 20.1625 2.47739 20.5219C2.83684 20.8814 3.32435 21.0833 3.83268 21.0833H17.2493C17.7577 21.0833 18.2452 20.8814 18.6046 20.5219C18.9641 20.1625 19.166 19.675 19.166 19.1666V12.4583",
    stroke: "#1473FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7285 2.39585C18.1098 2.0146 18.6268 1.80042 19.166 1.80042C19.7052 1.80042 20.2223 2.0146 20.6035 2.39585C20.9848 2.7771 21.1989 3.29418 21.1989 3.83335C21.1989 4.37251 20.9848 4.8896 20.6035 5.27085L11.4993 14.375L7.66602 15.3333L8.62435 11.5L17.7285 2.39585Z",
    stroke: "#1473FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01NowPriem);
export default __webpack_public_path__ + "static/media/01-now-priem.e3e8a233ba1ad0e238acd560fb142e42.svg";
export { ForwardRef as ReactComponent };